<template>
  <v-card class="backoffice-table" outlined>
    <v-data-table
      :headers="headers"
      :items="monthlyStats"
      :mobile-breakpoint="0"
      hide-default-footer
      height="344"
      fixed-header
    >
      <!-- Image Template -->
      <template v-slot:[`item.month`]="{ item }">
        <div class="gray-td">
          {{
            $moment()
              .month(item.month - 1)
              .format("MMMM")
          }}
        </div>
      </template>
      <template v-slot:[`item.profit`]="{ item }">
        <div
          :class="
            item.profit > 0 ? 'green-td' : item.profit < 0 ? 'red-td' : ''
          "
        >
          {{
            item.profit == 0 ? "-" : parseFloat(item.profit).toFixed(2) + "€"
          }}
        </div>
      </template>
      <template v-slot:[`item.avgOdd`]="{ item }">
        {{ parseFloat(item.avgOdd).toFixed(2) }}
      </template>
      <template v-slot:[`item.avgStake`]="{ item }">
        {{ parseFloat(item.avgStake).toFixed(2) }}
      </template>
      <template v-slot:[`item.roi`]="{ item }">
        {{ parseFloat(item.roi).toFixed(2) }}%
      </template>
      <!-- BODY APPEND -->
      <template v-slot:[`body.append`]="{ headers }">
        <tr v-for="n in itemsPerPage - monthlyStats.length" :key="'tr-' + n">
          <td :colspan="headers.length"></td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<style scoped>
td {
  font-family: Gilroy-SemiBold;
  line-height: 24px;
  height: 60px !important;
  padding: 2px 8px !important;
}
.gray-td {
  font-size: 12px !important;
  color: #bcc5cc;
  text-transform: capitalize;
}
.green-td {
  color: #26ab5e;
}
.red-td {
  color: #f83030;
}
.gray-btn {
  font-family: Gilroy-SemiBold;
  font-size: 14px !important;
  line-height: 24px;
  color: #9aabb8;
}
.ranking-row {
  height: 64px;
}
.ranking-avatar {
  border: 2px solid #26ab5e;
}
.ranking-row:nth-of-type(1) .ranking-avatar,
.ranking-row:nth-of-type(1) .v-badge__badge {
  border-color: #ffc121;
  background-color: #ffc121 !important;
}
.ranking-row:nth-of-type(2) .ranking-avatar,
.ranking-row:nth-of-type(2) .v-badge__badge {
  border-color: #bcc5cc;
  background-color: #bcc5cc !important;
}
.ranking-row:nth-of-type(3) .ranking-avatar,
.ranking-row:nth-of-type(3) .v-badge__badge {
  border-color: #ab8626;
  background-color: #ab8626 !important;
}
.ranking-title {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #304351 !important;
}
</style>

<script>
import Vue from "vue";

import ApiService from "@/services/api.service";

export default Vue.extend({
  name: "BigometroTable",
  props: { tableData: Array },
  data: () => ({
    tableHeader: [
      "Mês",
      "Lucro/prejuizo",
      "Odd média",
      "Stake média",
      "Roi/yeld",
      "Greens",
      "Reds",
      "Void",
    ],
    headers: [
      { text: "Mês", value: "month", sortable: false },
      { text: "Lucro/prejuizo", value: "profit", sortable: false },
      {
        text: "Odd média",
        value: "avgOdd",
        sortable: false,
      },
      {
        text: "Stake média",
        value: "avgStake",
        sortable: false,
      },
      {
        text: "Roi/yeld",
        value: "roi",
        sortable: false,
      },
      { text: "Greens", value: "greens", sortable: false },
      { text: "Reds", value: "reds", sortable: false },
      { text: "Voids", value: "voids", sortable: false },
    ],
    itemsPerPage: 10,
    monthlyStats: [],
  }),
  created() {
    this.getMonthlyStats();
  },
  methods: {
    isBackoffice() {
      return this.$route.path.includes("backoffice");
    },
    getMonthlyStats() {
      ApiService.getMonthlyBankStats(this.isBackoffice()).then(
        (response) => {
          this.monthlyStats = response.data;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
  },
});
</script>